// extracted by mini-css-extract-plugin
export default {"share_title":"ViewPDF_share_title__jY0Dz","share_social":"ViewPDF_share_social__jjr4z"};